<div class="wrapper relative flex flex-col justify-between h-full" (click)="handleGlobalClick($event)">
  <div class="mb-[30px] flex flex-row items-center justify-between">
    <v4-widget-image-caption>
      <div class="image-caption_image">
        <img
          class="w-[80px] h-[56px] rounded-[10px]"
          [src]="houseDetail?.cover_url || '/assets/status/placeholder.png'" />
      </div>
      <div class="image-caption_caption ml-3">
        <div class="text-l">{{ houseDetail?.house_title }}</div>
        <div class="flex flex-row items-center pt-1">
          <div class="v4-tag-list items-center" *ngIf="!tagEditing; else editTag">
            <div class="v4-tag-item mr-3 py-1" *ngFor="let tag of houseDetail?.tags">
              <div class="v4-tag" [style.backgroundColor]="tag.color">
                {{ tag.name }}
              </div>
            </div>
            <div class="py-1">
              <button
                nz-button
                nzSize="small"
                class="no-min-width mr-3"
                (click)="$event.stopPropagation(); tagEditing = true; autoFocusSelect()">
                {{
                  (houseDetail?.tags?.length
                    ? "order_basic-house_card_html-编辑标签"
                    : "order_basic-house_card_html-添加标签"
                  ) | translate
                }}
              </button>
            </div>
          </div>
          <ng-template #editTag>
            <nz-select
              (click)="$event.stopPropagation()"
              class="min-w-[100px] _antd-select"
              [nzPlaceHolder]="'order.add_tag' | translate"
              nzMode="multiple"
              [nzDropdownMatchSelectWidth]="false"
              [(ngModel)]="tagIds"
              (nzOpenChange)="onTagOpenChange($event)"
              [nzOptions]="optionsOfHouseTag"
              [nzDropdownRender]="renderTpl"></nz-select>
            <ng-template #renderTpl>
              <nz-divider class="mt-3 mb-3"></nz-divider>
              <div class="px-3 pb-3">
                <a nz-button nzType="link" (click)="toSettingOptionPage()">
                  <i nz-icon nzType="setting" nzTheme="outline"></i>
                  {{ "order.manage_tag" | translate }}
                  <!-- Manage tags -->
                </a>
              </div>
            </ng-template>
          </ng-template>

          <nz-avatar-group *ngIf="houseDetail?.thirdparty_types?.length">
            <nz-avatar
              *ngFor="let channel of houseDetail.thirdparty_types"
              [nzSrc]="(channel | thirdparty)?.icon_color_bg"
              nzSize="small"></nz-avatar>
          </nz-avatar-group>
        </div>
      </div>
    </v4-widget-image-caption>

    <div class="flex flex-row items-center">
      <button class="mr-2" nz-button (click)="onDisplayCalendar()">
        {{ "component.sidebar.order_form_title_calendar" | translate }}
        <!-- Calendar -->
      </button>
      <div class="circle-btn" (click)="onEditHouse()">
        <img class="w-4 h-4" src="/assets/v4/icon-modify.svg" alt="" />
        <!-- <i nz-icon nzType="edit" nzTheme="outline" class="text-[20px]"></i> -->
      </div>
      <div class="circle-btn" (click)="onRemoveHouse()">
        <img class="w-4 h-4" src="/assets/v4/icon-delete.svg" alt="" />
        <!-- <i nz-icon nzType="delete" nzTheme="outline" class="text-[20px]"></i> -->
      </div>
    </div>
  </div>

  <div class="flex flex-col flex-1 overflow-y-hidden">
    <nz-tabset class="h-full" nzSize="large" [(nzSelectedIndex)]="tab">
      <nz-tab [nzTitle]="'property-property_detail_html_tab_通用' | translate">
        <ng-template nz-tab>
          <property-detail-advanced [houseId]="id" [timezone]="houseDetail?.timezone"></property-detail-advanced>
        </ng-template>
      </nz-tab>
      <nz-tab [nzTitle]="'property-property_detail_html_tab_价格设置' | translate">
        <ng-template nz-tab>
          <property-detail-pricing
            [houseId]="id"
            [prices]="houseDetail?.house_prices"
            [originHouseId]="appendPageData?.origin_house_id"
            (onNavigate)="onSubpageNavigate()"></property-detail-pricing>
        </ng-template>
      </nz-tab>
      <nz-tab [nzTitle]="'property-property_detail_html_tab_pricint_ratio' | translate">
        <ng-template nz-tab>
          <property-detail-pricing-ratio [id]="id"></property-detail-pricing-ratio>
        </ng-template>
      </nz-tab>
      <nz-tab [nzTitle]="'property-property_detail_html_tab_关联的房源' | translate">
        <ng-template nz-tab>
          <property-detail-channels-linked [houseId]="id"></property-detail-channels-linked>
        </ng-template>
      </nz-tab>
    </nz-tabset>
  </div>

  <div class="pt-[30px] border-t border-c-gs border-solid bg-white">
    <button nz-button nzSize="large" (click)="onClose()">
      {{ "word.close" | translate }}
    </button>
  </div>
</div>
